export default __webpack_public_path__ + "static/media/postgres.1a96fb0a.png";